import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { alpha, useTheme } from "@mui/material/styles";

const PlayIcon = React.forwardRef(function PlayIcon(props, ref) {
  const { sx, circleOpacity, ...rest } = props;
  const theme = useTheme();
  const primary = theme.palette?.primary?.main || "#FFEE20";
  const opacity =
    typeof circleOpacity === "number"
      ? circleOpacity
      : theme.palette?.mode === "light"
      ? 0.18
      : 0.35;

  return (
    <SvgIcon
      {...rest}
      ref={ref}
      viewBox="0 0 32 32"
      sx={{
        fontSize: 32,
        ...sx,
      }}
    >
      <circle cx="16" cy="16" r="16" fill={alpha(primary, opacity)} />
      <path
        d="M13 10.9v10.2c0 .71.48 1.12 1.08.84l8.26-4.04a1 1 0 0 0 0-1.81l-8.26-4.04c-.6-.29-1.08.12-1.08.84Z"
        fill={primary}
      />
    </SvgIcon>
  );
});

export default PlayIcon;
